import "@mantine/core/styles.css"
import "@mantine/code-highlight/styles.css"
import "@mantine/spotlight/styles.css"
import "../stylesheets/spa.css"
import { startProject } from "../src/jsHeavy"
import { startAnalytics } from "../src/analytics"

startAnalytics()
startProject()
